import React, { ReactNode } from 'react'
import { Image, ImageSourcePropType, ImageStyle } from 'react-native'
import { StyleService, useStyleSheet } from '@src/style/service'
import { TouchableSection } from '@src/components'

interface IntegrationTouchableSectionProps {
  sectionTitle: string
  imageSource?: ImageSourcePropType
  accessoryLeft?: ReactNode
  onPress: () => void
}

export const IntegrationTouchableSection = ({
  sectionTitle,
  imageSource,
  accessoryLeft,
  onPress,
}: IntegrationTouchableSectionProps) => {
  const styles = useStyleSheet(themedStyles)

  const leftAccessory = accessoryLeft || (
    <Image source={imageSource} style={styles.providerImage as ImageStyle} />
  )

  return (
    <TouchableSection
      accessoryLeft={leftAccessory}
      title={sectionTitle}
      showRightArrow
      style={styles.providersSection}
      onPress={onPress}
    />
  )
}

const themedStyles = StyleService.create({
  providerImage: {
    width: 24,
    height: 24,
    marginRight: 12,
  },
  providersSection: {
    borderBottomWidth: 1,
    borderBottomColor: 'theme.surface.base',
  },
})
